import * as yup from 'yup';
import { FIELD_REQUIRED_MSG, INVALID_EMAIL_MSG } from '../../validation';

export const schema = yup.object().shape({
  activity: yup
    .string()
    .required(FIELD_REQUIRED_MSG)
    .typeError(FIELD_REQUIRED_MSG),
  allergies: yup.array(),
  stoolType: yup.string().nullable(),
  firstName: yup.string().required('name is a required field'),
  email: yup
    .string()
    .required('email is a required field')
    .email(INVALID_EMAIL_MSG),
});
